function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M512,256c0-9.218-0.498-18.316-1.448-27.283L399.946,118.112L217.217,309.791l-95.66,77.2 L246.367,511.8c3.198,0.119,6.406,0.198,9.631,0.198C397.384,512,512,397.384,512,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 177.855,
    style: {
      fill: "#324A5E"
    },
    width: 268.878,
    height: 209.127
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.431,
    y: 177.855,
    style: {
      fill: "#2B3B4E"
    },
    width: 135.016,
    height: 209.127
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.101,
    y: 237.623,
    style: {
      fill: "#B5F1F4"
    },
    width: 219.798,
    height: 119.501
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.431,
    y: 237.623,
    style: {
      fill: "#84DBFF"
    },
    width: 110.468,
    height: 119.501
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15D"
    },
    d: "M130.712,207.738L130.712,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C149.371,199.383,141.017,207.738,130.712,207.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M166.509,207.738L166.509,207.738c-10.305,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C185.168,199.383,176.814,207.738,166.509,207.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15D"
    },
    d: "M202.304,207.738L202.304,207.738c-10.305,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C220.965,199.383,212.609,207.738,202.304,207.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M238.101,207.738L238.101,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C256.76,199.383,248.406,207.738,238.101,207.738z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M273.898,207.738L273.898,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C292.557,199.383,284.203,207.738,273.898,207.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M345.49,207.738L345.49,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C364.149,199.383,355.795,207.738,345.49,207.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C18433"
    },
    d: "M309.693,207.738L309.693,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C328.352,199.383,319.998,207.738,309.693,207.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C18433"
    },
    d: "M381.285,207.738L381.285,207.738c-10.306,0-18.66-8.354-18.66-18.66v-70.966h37.319v70.968 C399.944,199.383,391.59,207.738,381.285,207.738z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C1321F"
    },
    cx: 256,
    cy: 297.374,
    r: 43.96
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A82116"
    },
    d: "M255.998,253.406c-0.193,0-0.383,0.012-0.574,0.014v87.89c0.191,0.002,0.381,0.016,0.574,0.016 c24.278,0,43.96-19.682,43.96-43.96C299.958,273.087,280.278,253.406,255.998,253.406z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.091,
    y: 271.331,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 226.7044 688.6447)",
    style: {
      fill: "#E6F3FF"
    },
    width: 9.769,
    height: 52.079
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FF"
    },
    d: "M242.4,292.033c-2.172,0-4.306-0.879-5.846-2.42c-1.533-1.541-2.419-3.667-2.419-5.846 s0.886-4.306,2.419-5.846c1.541-1.533,3.674-2.42,5.846-2.42c2.179,0,4.305,0.886,5.846,2.42c1.541,1.541,2.42,3.675,2.42,5.846 c0,2.179-0.879,4.306-2.42,5.846C246.705,291.154,244.579,292.033,242.4,292.033z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M269.598,319.229c-2.172,0-4.306-0.879-5.839-2.42c-1.541-1.541-2.427-3.667-2.427-5.846 c0-2.179,0.886-4.306,2.427-5.846c1.533-1.541,3.667-2.42,5.839-2.42c2.179,0,4.305,0.879,5.846,2.42 c1.541,1.541,2.42,3.674,2.42,5.846c0,2.172-0.879,4.306-2.42,5.846C273.903,318.35,271.775,319.229,269.598,319.229z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/Products.8d65e6ba4853e13ddaea81bf9fd4a10d.svg";
export { ForwardRef as ReactComponent };